'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import type { ReactNode } from 'react';
import { useEffect } from 'react';

import Footer from '@/layouts/footer';
import Header from '@/layouts/header';
import { useLayout } from '@/provider/LayoutProvider';

type IMainProps = {
  meta?: ReactNode;
  children: ReactNode;
  withOnlyHeader?: boolean;
  withEmptyLayout?: boolean;
  isHotStyle?: boolean;
};

const Main = (props: IMainProps) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const { setIsLoadingBar, isLoadingBar } = useLayout();

  useEffect(() => {
    if (isLoadingBar) {
      setIsLoadingBar(false);
    }
  }, [pathname, searchParams]);

  useEffect(() => {
    window.addEventListener('error', (e) => {
      if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        // prevent React's listener from firing
        e.stopImmediatePropagation();
        // prevent the browser's console error message
        e.preventDefault();
      }
    });
  }, []);

  return (
    <div className="w-full text-black">
      {props.meta}

      <div className="w-full">
        {!props.withEmptyLayout && <Header isHotStyle={props?.isHotStyle} />}

        <div className="text-black">{props.children}</div>

        {!props.withEmptyLayout && !props.withOnlyHeader && <Footer />}
      </div>
    </div>
  );
};

export default Main;
